import axiosIns from '@/libs/axios'

export default {
  namespaced: true,
  actions: {
    fetchPromoCodesList(_, params) {
      return axiosIns.get('promos/coupons/', {
        params,
      })
    },
    getPromoCode(_, id) {
      return axiosIns.get(`promos/coupons/${id}`)
    },
    createPromoCode(_, data) {
      return axiosIns.post('promos/coupons', data)
    },
    patchPromoCode(_, { id, data }) {
      return axiosIns.patch(`promos/coupons/${id}`, data)
    },
  },
}
